<template>
  <div id="subscription-show">
    <disabled-overlay />
    <profile-module />
    <div class="text-center mt-5 mb-4">
      <span class="little-title">{{ $t('pages.subscription.sub_title') }}</span>
      <div class="date mt-3 mb-3">{{ validityDate }}</div>
      <div class="mb-4 subscription-mail">
        <b-button
          v-if="$root.canManage()"
          variant="info"
          offset-sm="4"
          sm="4"
          @click="sendEmail"
        >
          {{ $t('pages.subscription.email') }}
        </b-button>
        <span v-if="$root.canManage()" id="subscription-mail-help">{{ $t('pages.subscription.help.title') }}</span>
      </div>
      <b-tooltip
        target="subscription-mail-help"
        placement="right"
      >
        <span>{{ $t('pages.subscription.help.text') }}</span>
      </b-tooltip>
      <p
        class="intro"
        v-html="$t('pages.subscription.intro', {first_name: get().memorial.first_name, last_name: get().memorial.last_name})"
      />
    </div>
    <e-index
      :uri="getUri()"
      :modal-uri-create="`api/public/memorial/${id}/subscription`"
      :modal-uri="`api/memorial/${id}/subscription`"
      :order-call-back="orderCallBack"
      :has-paypal="true"
      :config="{ headers: { 'Content-Language': $translation.getLocale() } }"
      name="subscription"
      mode="table"
    >
      <h5 slot="title">{{ $t('pages.subscription.table_title') }}</h5>
      <tr slot="table-header">
        <th>{{ $t('form.date') }}</th>
        <th>{{ $t('form.name') }}</th>
        <th v-if="$root.canManage()">{{ $t('form.email') }}</th>
      </tr>
      <template slot="table-content" slot-scope="ctx">
        <td>{{ $t('form.at') }} {{ ctx.item.updated_at | moment('LL') }}</td>
        <td>{{ $t('form.by') }} {{ ctx.item.contact.first_name }} {{ ctx.item.contact.last_name }}</td>
        <td v-if="$root.canManage()"><a :href="`mailto:${ctx.item.contact.email}`">{{ ctx.item.contact.email }}</a></td>
      </template>
    </e-index>
  </div>
</template>

<script>
  import EIndex from '@/components/EIndex';
  import ProfileModule from '@/components/ProfileModule';
  import TModal from '@triotech/vue-core/src/components/TModal';
  import DisabledOverlay from '@/components/DisabledOverlay';
  import MemorialGuard from '@/mixins/MemorialGuard';

  export default {
    name: 'SubscriptionIndex',
    components: {
      EIndex,
      TModal,
      ProfileModule,
      DisabledOverlay,
    },
    mixins: [
      MemorialGuard,
    ],
    props: {
      id: {
        type: [Number, String],
        default: null,
      },
    },
    data() {
      const { memorial } = this.get();
      return {
        // eslint-disable-next-line no-underscore-dangle
        uid: this._uid,
        image: '',
        memorial,
        paypalButtonId: '#paypal-button-container',
      };
    },
    computed: {
      validityDate() {
        return this.$moment(this.memorial.validity_date).format('LL');
      },
    },
    mounted() {
      this.$bus.$on('t-event.new-submit.subscription.success', async () => {
        this.memorial = await this.getMemorial();
        this.set({ memorial: this.memorial });
      });
    },
    methods: {
      sendEmail() {
        this.$ajax.get(`api/memorial/${this.get().memorial.id}/subscription/remind`, {}, { headers: { 'Content-Language': this.$translation.getLocale() } })
          .then((response) => {
            if (response.status === 'ok') {
              this.$notify({
                title: this.$t('flashes.subscription.email.title'),
                text: this.$t('flashes.subscription.email.success'),
                type: 'success',
              });
            }
          });
      },
      getUri() {
        return `api/public/memorial/${this._.get(this.get(), 'memorial.id')}/subscription/`;
      },
      modalName(action) {
        return `${action}-${this.uid}`;
      },
      openModal(id, data = null) {
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
      orderCallBack(collection) {
        return _.orderBy(collection, ['created_at'], ['desc']);
      },
      async getMemorial() {
        const identifier = this.$route.params.id;
        return this.$ajax.get(`api/public/memorial/${identifier}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@triotech/vue-core/src/scss/bootstrap';

  /deep/ form .vue-form-generator{
    .field-hidden {
      display: none;
    }
  }

  .little-title {
    font-size: 1.3rem;
  }

  .date {
    font-size: 3.5rem;
  }

  .subscription-mail {
    position: relative;
    display: inline-block;

    #subscription-mail-help {
      color: $primary;
      font-weight: bold;
      font-size: 1.5rem;
      position: absolute;
      right: -30px;
      top: 0;
      cursor: pointer;
    }
  }

  .intro {
    font-size: 1rem;
  }

  /deep/ .table {
    margin-top: 20px;

    td {
      a {
        color: $primary !important;
      }
    }
  }

  @include media-breakpoint-down(xs) {
    #subscription-show {
      /deep/ .modal-form {
        overflow: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Subscription/index.vue